import { usePasswordLostMutation } from '@http/queries.js';
import { LoadingButton } from '@mui/lab';
import { TextField, Typography } from '@mui/material';
import { IconMail } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ForgotPassword() {
    const [submitting, setSubmitting] = useState(false);
    const [requestResponse, setRequestResponse] = useState();
    const pwLostMutation = usePasswordLostMutation();

    const [emailFieldError, setEmailFieldError] = useState('');

    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const { t } = useTranslation();

    function validateForm(fieldName, newFormData) {
        let valid = true;
        let tempErrors = '';

        if (!newFormData) newFormData = formData;

        const password = newFormData.password.trim();
        const email = newFormData.email.trim();

        // fix for browser autofill, force validation of both fields
        if (password && email) fieldName = '';

        if (fieldName === 'email' || !fieldName) {
            const error = validateEmail(email);
            if (error) {
                valid = false;
                tempErrors = error;
            } else {
                tempErrors = '';
            }
        }

        setEmailFieldError(tempErrors);
        return valid;
    }

    function handleChange(e) {
        const { name, value } = e.target;

        setFormData(prevFormData => {
            const newFormData = { ...prevFormData, [name]: value };
            // Directly validate form after state update
            validateForm(name, newFormData);
            return newFormData;
        });
    }

    function validateEmail(email) {
        if (!email) return t('emailRequired');

        if (!email.includes('@')) return t('emailInvalid');

        return '';
    }

    async function handleSubmitForgotPassword(e) {
        e?.preventDefault();

        setSubmitting(true);

        const emailError = validateEmail(formData.email);

        if (emailError) {
            setEmailFieldError(emailError);
            setSubmitting(false);
            return;
        }

        const email = formData.email.trim();

        try {
            const user = await pwLostMutation.mutateAsync({
                email
            });

            console.log('PW Lost successful', user);

            setRequestResponse({ isError: false, message: t('passwordForgotSuccess') });
        } catch (error) {
            console.error('PW Lost error:', error);
            setRequestResponse({ isError: true, message: t('errorTryAgain') });
        }

        setSubmitting(false);
    }

    return (
        <form onSubmit={handleSubmitForgotPassword}>
            <Typography>{t('passwordForgotDescription')}</Typography>

            {requestResponse ? (
                <Typography
                    variant='h3'
                    sx={{
                        color: requestResponse?.isError ? '#b60000' : '#00b600',
                        my: 2
                    }}
                >
                    {requestResponse.message}
                </Typography>
            ) : null}

            <TextField
                label={t('email')}
                autoComplete='email'
                type='email'
                autoFocus
                error={!!emailFieldError}
                fullWidth
                helperText={emailFieldError}
                id='email'
                margin='normal'
                name='email'
                onBlur={() => validateForm('email')}
                onChange={handleChange}
                onInput={handleChange}
                sx={{
                    mt: 3
                }}
                value={formData.email}
                variant='outlined'
            />

            <LoadingButton
                sx={{ mt: 3 }}
                fullWidth
                loading={submitting}
                startIcon={<IconMail />}
                type='submit'
                variant='contained'
                size='large'
            >
                {t('requestLink')}
            </LoadingButton>
        </form>
    );
}
